var _g, _g2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_1_",
    "data-name": "user (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.979,
    height: 63.979,
    viewBox: "0 0 63.979 63.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3270",
    "data-name": "Group 3270",
    transform: "translate(38.364 33.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22289",
    "data-name": "Path 22289",
    d: "M331.812,269.056a28.432,28.432,0,0,0-23.982,0,1.374,1.374,0,0,0-.816,1.256v7.814a20.644,20.644,0,0,0,12.249,18.849,1.374,1.374,0,0,0,1.117,0,20.644,20.644,0,0,0,12.249-18.849v-7.814A1.374,1.374,0,0,0,331.812,269.056Zm-1.933,9.07A17.9,17.9,0,0,1,319.82,294.2a17.894,17.894,0,0,1-10.058-16.077v-6.907a25.625,25.625,0,0,1,20.117,0Z",
    transform: "translate(-307.013 -266.403)",
    fill: "#61ce65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22290",
    "data-name": "Path 22290",
    d: "M368.5,359.705a1.375,1.375,0,1,0-1.944,1.944l2.695,2.695a1.375,1.375,0,0,0,1.944,0l5.39-5.39a1.375,1.375,0,0,0-1.944-1.944l-4.418,4.418Z",
    transform: "translate(-358.767 -345.336)",
    fill: "#61ce65"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3271",
    "data-name": "Group 3271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22291",
    "data-name": "Path 22291",
    d: "M122.193,123.36v-1.415a10.134,10.134,0,0,0-5.817-9.158,6.456,6.456,0,1,0-8.9,0,10.134,10.134,0,0,0-5.817,9.158v1.415a1.375,1.375,0,0,0,1.375,1.375h17.785A1.374,1.374,0,0,0,122.193,123.36Zm-10.267-18.951a3.707,3.707,0,1,1-3.707,3.707A3.711,3.711,0,0,1,111.926,104.409Zm7.518,17.576H104.408v-.041a7.381,7.381,0,0,1,7.373-7.373h.29a7.381,7.381,0,0,1,7.373,7.373v.041Z",
    transform: "translate(-88.956 -88.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22292",
    "data-name": "Path 22292",
    d: "M113.2,389.056h15.244a1.375,1.375,0,1,0,0-2.749H113.2a1.375,1.375,0,1,0,0,2.749Z",
    transform: "translate(-97.852 -338.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22293",
    "data-name": "Path 22293",
    d: "M45.94,33.792V14.078a1.386,1.386,0,0,0-.4-.972L32.834.4a1.387,1.387,0,0,0-.972-.4H5.186A5.191,5.191,0,0,0,0,5.186V53.458a5.191,5.191,0,0,0,5.186,5.186h38.33a20.687,20.687,0,0,1-2.039-2.749H5.186a2.439,2.439,0,0,1-2.436-2.436V5.186A2.439,2.439,0,0,1,5.186,2.749h25.3v7.518a5.191,5.191,0,0,0,5.186,5.186h7.518V34.463Q44.564,34.059,45.94,33.792ZM35.673,12.7a2.439,2.439,0,0,1-2.436-2.436V4.693l8.01,8.01Z",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2332",
    "data-name": "Ellipse 2332",
    cx: 1.375,
    cy: 1.375,
    r: 1.375,
    transform: "translate(13.974 40.65)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2333",
    "data-name": "Ellipse 2333",
    cx: 1.375,
    cy: 1.375,
    r: 1.375,
    transform: "translate(21.595 40.65)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2334",
    "data-name": "Ellipse 2334",
    cx: 1.374,
    cy: 1.374,
    r: 1.374,
    transform: "translate(29.218 40.65)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.9c51cdfc022a3624c91ec08d9b9826d5.svg";
export { ForwardRef as ReactComponent };